import { render, staticRenderFns } from "./tem-builder.vue?vue&type=template&id=9285646a&scoped=true"
import script from "./tem-builder.vue?vue&type=script&lang=ts"
export * from "./tem-builder.vue?vue&type=script&lang=ts"
import style0 from "./tem-builder.vue?vue&type=style&index=0&id=9285646a&prod&lang=scss&scoped=true"
import style1 from "./tem-builder.vue?vue&type=style&index=1&id=9285646a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9285646a",
  null
  
)

export default component.exports